module.exports = __webpack_public_path__ + "static/6-3d2c042e9bbe921d29653958898d846a.jpg";